import { SafeSessionStorage } from '#pplx/frontend/browser-storage/sessionStorage.js';
import { safeRandomUUID } from '#pplx/frontend/common/safeRandomUUID.js';
const REMIX_ATTACHMENT_HANDOFF_PREFIX = 'pplx.computer.remixAttachmentHandoff';
export function getRemixStartAttribution(attachments) {
    const metadata = attachments?.find((attachment) => attachment.metadata?.kind === 'remix_asset')?.metadata;
    if (metadata?.kind !== 'remix_asset' || !metadata.sourceAssetUUID || !metadata.handoffId) {
        return null;
    }
    return {
        asset_uuid: metadata.sourceAssetUUID,
        handoffId: metadata.handoffId,
    };
}
export function createRemixAssetAttachmentHandoff(handoff) {
    const id = safeRandomUUID();
    const key = `${REMIX_ATTACHMENT_HANDOFF_PREFIX}:${id}`;
    const ok = SafeSessionStorage.setItem(key, JSON.stringify(handoff));
    return ok ? id : null;
}
export function getRemixAssetAttachmentHandoff(id) {
    const key = `${REMIX_ATTACHMENT_HANDOFF_PREFIX}:${id}`;
    const raw = SafeSessionStorage.getItem(key);
    if (!raw) {
        return null;
    }
    try {
        return JSON.parse(raw);
    }
    catch {
        return null;
    }
}
export function clearRemixAssetAttachmentHandoff(id) {
    SafeSessionStorage.removeItem(`${REMIX_ATTACHMENT_HANDOFF_PREFIX}:${id}`);
}
//# sourceMappingURL=remixAssetAttachments.js.map